<div class="container-fluid bg-white px-0 h-100" id="explore-roles" >
    <div class="row">
        <div class="col-md-12">
            <div class="row">
                <div class="col-md-9 mt-14">
                    <!-- My Profile -->
                    <div id="myprofile" *ngIf="listArray[0].isShown">
                        <div class="row ml-5">
                            <div class="section_header col-md-10">
                                <h5>
                                    <img class="img-size"
                                        src="https://intimeprosstorage.blob.core.windows.net/intimepros-cdn/my_profile.svg"
                                        alt="">
                                    <b class="ml-5">{{ 'MyProfile' | localize}} </b>

                                </h5>
                            </div>
                            <div class="col-md-2 sortable">
                                <span class="text-right" (click)="homePage()">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="#0095DA"
                                        class="bi bi-house-door mr-2" viewBox="0 0 16 16">
                                        <path
                                            d="M8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4.5a.5.5 0 0 0 .5-.5v-4h2v4a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146zM2.5 14V7.707l5.5-5.5 5.5 5.5V14H10v-4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v4H2.5z" />
                                    </svg><span class="mt-1 text-primary">
                                        {{'Home'| localize}}
                                    </span>
                                </span>
                            </div>
                        </div>
                        <hr>

                        <div class="mt-1 ">
                            <div class="container">
                                <div class="accordion" id="accordionExample">
                                    <div class="card">
                                        <div class="card-head mb-0" data-toggle="collapse" aria-controls="collapseOne"
                                            id="headingOne" (click)="accordianOpen(0)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{'WhatisMyProfile' | localize}}
                                                </li>
                                            </h2>
                                        </div>

                                        <div id="collapseOne" class="show" aria-labelledby="headingOne">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    <span>
                                                        {{'SubIsindividualuser' | localize}}
                                                    </span><br>
                                                </div>
                                                <div class="text-muted ml-5">
                                                    <span>
                                                        {{'Isindividualuser' | localize}}
                                                    </span><br>
                                                </div>
                                             
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="collapsed card-head mb-0" data-toggle="collapse"
                                            aria-controls="collapseTwo" id="headingTwo" (click)="accordianOpen(1)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{'Whatarethefeaturesofmyprofile' | localize}}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo">
                                            <div class="card-body">
                                                <div class="text-muted ">
                                                    <ul>
                                                        <li>{{'Usercanedit' | localize}} </li>
                                                        <li>{{'Profilepicture' | localize}}</li>
                                                        <li> {{'Changepasswordisused' | localize}} </li>

                                                        <li> {{'LogoutofallintimePro' | localize}} </li>

                                                        <li>{{'ThisincludesintimePro' |localize}} </li>

                                                    </ul>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Company Profile -->
                    <div id="companyprofile" *ngIf="listArray[7].isShown">
                        <div class="row ml-5 ">
                            <div class="section_header col-md">
                                <h5>
                                    <img class="img-size"
                                        src="https://intimeprosstorage.blob.core.windows.net/intimepros-cdn/company_profile.svg"
                                        alt="">
                                    <b class="ml-5">{{ 'Companyprofile' | localize}} </b>

                                </h5>
                            </div>
                            <div class="col-md-2 sortable">
                                <span class="text-right" (click)="homePage()">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="#0095DA"
                                        class="bi bi-house-door mr-2" viewBox="0 0 16 16">
                                        <path
                                            d="M8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4.5a.5.5 0 0 0 .5-.5v-4h2v4a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146zM2.5 14V7.707l5.5-5.5 5.5 5.5V14H10v-4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v4H2.5z" />
                                    </svg><span class="mt-1 text-primary">
                                        {{'Home'| localize}}
                                    </span>
                                </span>
                            </div>

                        </div>
                        <hr>
                        <div class="mt-1">
                            <div class="container">
                                <div class="accordion" id="accordionExample">
                                    <div class="card">
                                        <div class="card-head mb-0" data-toggle="collapse" aria-controls="collapseOne"
                                            id="headingOne" (click)="accordianOpen(0)">
                                            <h2>
                                                <li class="text-font mt-2">{{'WhatisCompanyProfile' |localize}}</li>
                                            </h2>
                                        </div>

                                        <div id="collapseOne" class="show" aria-labelledby="headingOne">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    <span> {{'SubCompanyProfilecontains' | localize}}</span><br>
                                                </div>
                                                <div class="text-muted ml-5">
                                                    <span> {{'CompanyProfilecontains' | localize}}</span><br>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class=" collapsed card-head mb-0" data-toggle="collapse"
                                            aria-controls="collapseTwo" id="headingTwo" (click)="accordianOpen(1)">
                                            <h2>
                                                <li class="text-font mt-2">{{'Companydetails' | localize}}</li>
                                            </h2>
                                        </div>
                                        <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    {{
                                                    'Thisiswhere' |
                                                    localize
                                                    }}
                                                </div>
                                                <ul>
                                                    <li> {{'Organizationname' | localize}}</li>
                                                    <li> {{'Organizationaddress' | localize}}</li>
                                                    <li> {{'Owner' | localize}}</li>
                                                    <li> {{'Timezones' | localize}}</li>
                                                    <li> {{'Dateformat' | localize}}</li>
                                                    <li> {{'Defaulthourlyrate' | localize}}</li>
                                                    <li> {{'Businessphone' | localize}}</li>
                                                    <li> {{'Basecurrency' | localize}}</li>
                                                    <li> {{'Emailrecipients' | localize}}</li>
                                                    <li> {{'Sendemailreport' | localize}}</li>
                                                    <li> {{'CompanyLogo' | localize}}</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class=" collapsed card-head mb-0" data-toggle="collapse"
                                            aria-controls="collapseThree" id="headingThree" (click)="accordianOpen(2)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{'Locations' | localize}}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseThree" class="collapse" aria-labelledby="headingThree">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    <span> {{'Locationsare' | localize}}</span><br>
                                                    <span>
                                                        {{
                                                        'Youcanaddnewlocation' |
                                                        localize
                                                        }}
                                                    </span><br>
                                                    <span> {{'Filterbylocation' | localize}}</span><br>
                                                    <span> {{'Youcanedit' | localize}}</span><br>
                                                    <span> {{'Youcanassign' | localize}}</span><br>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseFour" id="headingFour" (click)="accordianOpen(3)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{'TrackWorkingDay' | localize}}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseFour" class="collapse" aria-labelledby="headingFour">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    <span>
                                                        {{'Thisiswhereyoucanadd' | localize}}
                                                    </span><br>
                                                </div>
                                                <ul>
                                                    <li>{{'Workingdaysarethedays' | localize}}</li>
                                                    <li>{{'Selectthelocation' | localize}}</li>
                                                    <li>{{'Selectworkingdays' | localize}}</li>
                                                    <li>{{'Workstarts' | localize}}</li>
                                                    <li>{{'Workends' | localize}}</li>
                                                    <li>{{'Minimumhours' | localize}}</li>
                                                    <li>{{'Turnontoggle' | localize}}</li>
                                                </ul>
                                                <div class="text-font ml-5">
                                                    {{'Howtosetuptrackingdays' | localize}}
                                                </div>
                                                <div class="text-muted ml-5">
                                                    <span> {{'TrackWorkingDays' | localize}}</span><br>
                                                </div>
                                                <ul>
                                                    <li>{{'Selectthelocations' | localize}}</li>
                                                    <li>{{'Selecttimezones' | localize}}</li>
                                                    <li>{{'Selecttrackingday' | localize}}</li>
                                                    <li>{{'TrackingEnds' | localize}}</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="collapsed card-head mb-0" data-toggle="collapse"
                                            aria-controls="collapseFive" id="headingFive" (click)="accordianOpen(4)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{'PublicHolidays' | localize}}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseFive" class="collapse" aria-labelledby="headingFive">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    <span>
                                                        {{'Youcanaddpublicholiday' | localize}}
                                                    </span><br>
                                                </div>
                                                <div class="text-font ml-5">
                                                    {{'Howtoaddholiday' | localize}}
                                                </div>
                                                <ul>
                                                    <li>{{'ClickonAddHoliday' | localize}}</li>
                                                    <li>{{'Selectholidaydate' | localize}}</li>
                                                    <li>{{'Addholidayname' | localize}}</li>
                                                    <li>{{'Selectedthelocation' | localize}}</li>
                                                    <li>{{'AddDescription' | localize}}</li>
                                                    <li>{{'Clickonsave' | localize}}</li>
                                                    <li>{{'Thisaddedholiday' | localize}}</li>
                                                    <li>{{'Youcaneditordelete' | localize}}</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseSix" id="headingSix" (click)="accordianOpen(5)">
                                            <h2>
                                                <li class="text-font mt-2">{{'CaptureSettings' | localize}}</li>
                                            </h2>
                                        </div>
                                        <div id="collapseSix" class="collapse" aria-labelledby="headingSix">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    <span>
                                                        {{'Youcansetupyouremployee' | localize}}
                                                    </span><br>
                                                </div>
                                                <ul>
                                                    <span class="text-font">
                                                        {{'Screenshot' | localize}}
                                                    </span>
                                                    <div class="ml-5">
                                                        <li>
                                                            {{'EnableScreenCapture' | localize}}
                                                        </li>
                                                        <li>
                                                            {{'BlurScreenCapture' | localize}}
                                                        </li>
                                                        <li>
                                                            {{'Screencaptureinterval' | localize}}
                                                        </li>
                                                        <li>
                                                            {{'ScreenCaptureQualitys' | localize}}
                                                        </li>
                                                    </div>
                                                </ul>
                                                <ul>
                                                    <span class="text-font">
                                                        {{'Tracking' | localize}}
                                                    </span>
                                                    <div class="ml-5">
                                                        <li>
                                                            {{'Disableapptracking' | localize}}
                                                        </li>
                                                        <li>
                                                            {{'DisableURLtracking' | localize}}
                                                        </li>
                                                        <li>
                                                            {{'Disableprivatetime' | localize}}
                                                        </li>
                                                        <li>
                                                            {{'Idletimetracking' | localize}}
                                                        </li>
                                                        <li> {{'Offlinetime' | localize}}</li>
                                                        <li> {{'Ifenabled' | localize}}</li>
                                                        <li> {{'Ifdisable' | localize}}</li>
                                                        <li> {{'Ifapprove' | localize}}</li>
                                                    </div>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>

                    <!-- Organization Unit  -->
                    <div id="organizationunit" *ngIf="listArray[8].isShown">
                        <div class="row ml-5 ">
                            <div class="section_header col-md">
                                <h5>
                                    <img class="img-size"
                                        src="https://intimeprosstorage.blob.core.windows.net/intimepros-cdn/organization_unit.svg"
                                        alt="">
                                    <b class="ml-5">{{ 'OrganizationUni' | localize}} </b>

                                </h5>
                            </div>
                            <div class="col-md-2 sortable">
                                <span class="text-right" (click)="homePage()">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="#0095DA"
                                        class="bi bi-house-door mr-2" viewBox="0 0 16 16">
                                        <path
                                            d="M8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4.5a.5.5 0 0 0 .5-.5v-4h2v4a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146zM2.5 14V7.707l5.5-5.5 5.5 5.5V14H10v-4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v4H2.5z" />
                                    </svg><span class="mt-1 text-primary"> {{'Home'| localize}} </span>
                                </span>
                            </div>
                        </div>
                        <hr>

                        <div class="mt-1">
                            <div class="container">
                                <div class="accordion" id="accordionExample">
                                    <div class="card">
                                        <div class="card-head mb-0" data-toggle="collapse" aria-controls="collapseOne"
                                            id="headingOne" (click)="accordianOpen(0)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{'WhatisOrganizationUnit' | localize}}
                                                </li>
                                            </h2>
                                        </div>

                                        <div id="collapseOne" class="show" aria-labelledby="headingOne">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    <span>
                                                        {{'SubAftersettingupcompanyprofilee' | localize}}
                                                    </span><br>
                                                </div>
                                                <div class="text-muted ml-5">
                                                    <span>
                                                        {{'Aftersettingupcompanyprofile' | localize}}
                                                    </span><br>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="collapsed card-head mb-0" data-toggle="collapse"
                                            aria-controls="collapseTwo" id="headingTwo" (click)="accordianOpen(1)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{'Howtoaddrootunit' | localize}}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    {{'Usercanaddorganization' | localize}} <br>
                                                    {{'Rootunitisthedefaultorganization' | localize}}
                                                    <br>
                                                    {{'Tosetuporganizationunit' | localize}}
                                                </div>
                                                <ul>
                                                    <li>{{'Enterrootunitname' | localize}}</li>
                                                    <li>{{'Enterdescription' | localize}}</li>
                                                    <li>{{'Uploadpictureforroot' | localize}}</li>
                                                </ul>
                                                <div class="text-muted ml-5">
                                                    {{'Thiswillcreaterootunit' | localize}} <br>
                                                    {{'Nowusercanaddmultiple' | localize}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="collapsed card-head mb-0" data-toggle="collapse"
                                            aria-controls="collapseThree" id="headingThree" (click)="accordianOpen(2)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{
                                                    'Addusertoorganizationunit'
                                                    | localize
                                                    }}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseThree" class="collapse" aria-labelledby="headingThree">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    {{'Ifadminwantstoaddanyuser' | localize}} <br>
                                                    {{'OnclickofAddUsers' | localize}} <br>
                                                    {{'Ifthelistisblank' | localize}} <br>
                                                    {{'Selecteduserfromthelist' | localize}} <br>
                                                    {{'Ifuserwantstoremove' | localize}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseFour" id="headingFour" (click)="accordianOpen(3)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{
                                                    'Howtoeditorganizationunit'
                                                    | localize
                                                    }}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseFour" class="collapse" aria-labelledby="headingFour">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    {{'Usercanclickon' | localize}} <br>
                                                    {{'Thisallowsusertoedit' | localize}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="collapsed card-head mb-0" data-toggle="collapse"
                                            aria-controls="collapseFive" id="headingFive" (click)="accordianOpen(4)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{'Howtodeleteorganizationunit' | localize}}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseFive" class="collapse" aria-labelledby="headingFive">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    {{'Usercandelete' | localize}} <br>
                                                    {{'Usercannotdelete' | localize}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Download Agent App -->
                    <div id="downloadagantapp" *ngIf="listArray[12].isShown">
                        <div class="row ml-5 ">
                            <div class="section_header col-md">
                                <h5>
                                    <img class="img-size"
                                        src="https://intimeprosstorage.blob.core.windows.net/intimepros-cdn/download_agent_app.svg"
                                        alt="">
                                    <b class="ml-5">{{ 'DownloadAgentApp' | localize}} </b>
                                </h5>
                            </div>
                            <div class="col-md-2 sortable">
                                <span class="text-right" (click)="homePage()">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="#0095DA"
                                        class="bi bi-house-door mr-2" viewBox="0 0 16 16">
                                        <path
                                            d="M8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4.5a.5.5 0 0 0 .5-.5v-4h2v4a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146zM2.5 14V7.707l5.5-5.5 5.5 5.5V14H10v-4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v4H2.5z" />
                                    </svg><span class="mt-1 text-primary"> {{'Home'| localize}} </span>
                                </span>
                            </div>

                        </div>
                        <hr>
                        <div class="mt-1">
                            <div class="container">
                                <div class="accordion" id="accordionExample">
                                    <div class="card">
                                        <div class="card-head mb-0" data-toggle="collapse" aria-controls="collapseOne"
                                            id="headingOne" (click)="accordianOpen(0)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{ 'HowtoDownloadAgentApp' | localize}}
                                                </li>
                                            </h2>
                                        </div>

                                        <div id="collapseOne" class="show" aria-labelledby="headingOne">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    {{'SubAgentapptrackstheactivitiesofemployeeHeading' | localize}}
                                                </div>
                                                <div class="text-muted ml-5">
                                                    <span>
                                                        {{'Agentapptrackstheactivitiesofemployee' | localize}}
                                                    </span><br>
                                                    <span>
                                                        {{'Intimeprohasagentapplication' | localize}}
                                                    </span><br>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseTwo" id="headingTwo" (click)="accordianOpen(1)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{'WhatagentappTracks' | localize}}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo">
                                            <div class="card-body">
                                                <ul>
                                                    <li>{{'Trackstheapplications' | localize}}</li>
                                                    <li>{{'Capturescreenshot' | localize}}</li>
                                                    <li>{{'Capturesblurscreenshots' | localize}}</li>
                                                    <li>{{'Calculatesmouseevent' | localize}}</li>
                                                    <li>{{'Trackslivelocation' | localize}}</li>
                                                    <li>{{'Tracksprivatetimeofuser' | localize}}</li>
                                                    <li>
                                                        {{'Tracksidletimeandofflinetime' | localize}}
                                                    </li>
                                                </ul>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- TimeOff -->
                    <div id="timeoff" *ngIf="listArray[3].isShown">
                        <div class="row ml-5 ">
                            <div class="section_header col-md">
                                <h5>
                                    <img class="img-size"
                                        src="https://intimeprosstorage.blob.core.windows.net/intimepros-cdn/time_off.svg"
                                        alt="">
                                    <b class="ml-5">{{ 'leave' | localize}} </b>

                                </h5>
                            </div>
                            <div class="col-md-2 sortable">
                                <span class="text-right" (click)="homePage()">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="#0095DA"
                                        class="bi bi-house-door mr-2" viewBox="0 0 16 16">
                                        <path
                                            d="M8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4.5a.5.5 0 0 0 .5-.5v-4h2v4a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146zM2.5 14V7.707l5.5-5.5 5.5 5.5V14H10v-4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v4H2.5z" />
                                    </svg><span class="mt-1 text-primary"> {{'Home'| localize}} </span>
                                </span>
                            </div>

                        </div>
                        <hr>
                        <div class="mt-1">
                            <div class="container">
                                <div class="accordion" id="accordionExample">
                                    <div class="card">
                                        <div class="card-head mb-0" data-toggle="collapse" aria-controls="collapseOne"
                                            id="headingOne" (click)="accordianOpen(0)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{
                                                    'Whatisleaves' |
                                                    localize
                                                    }}
                                                </li>
                                            </h2>
                                        </div>

                                        <div id="collapseOne" class="show" aria-labelledby="headingOne">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    {{'Managingleaveisacrucialpart' | localize}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseTwo" id="headingTwo" (click)="accordianOpen(1)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{
                                                    'Howtoaddawaytime' |
                                                    localize
                                                    }}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    {{'Youcanaddyourawaytime' | localize}}
                                                </div>
                                                <ul>
                                                    <li>
                                                        {{'Selectteamandmember' | localize}}
                                                    </li>
                                                    <li>
                                                        {{'Selectfromdateandtodate' | localize}}
                                                    </li>
                                                    <li>
                                                        {{'SelectLeaveTypeandifhalfday' | localize}}
                                                    </li>
                                                    <li>
                                                        {{'SelectAwaytimetype' | localize}}
                                                    </li>
                                                    <li>
                                                        {{'Addreasonforleaveandclick' | localize}}
                                                    </li>
                                                </ul>
                                                <span class="text-muted ml-5">
                                                    {{'Youcanseethehistory' | localize}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-head mb-0 collapsed" data-toggle="collapse"
                                            aria-controls="collapseThree" id="headingThree" (click)="accordianOpen(2)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{'WhatisMyleave' | localize}}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseThree" class="collapse" aria-labelledby="headingThree">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    {{'Addedawaytimewilldisplayinmytime' | localize}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseFour" id="headingFour" (click)="accordianOpen(3)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{'WhatisCalendar' | localize}}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseFour" class="collapse" aria-labelledby="headingFour">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    {{'Thistabrepresentsthecalendarview' | localize}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseFive" id="headingFive" (click)="accordianOpen(4)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{'WhatareApprovals' | localize}}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseFive" class="collapse" aria-labelledby="headingFive">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    <span>
                                                        {{'Thisisthelistofalladdedawaytime' | localize}}
                                                    </span><br>
                                                    <span> {{'Timeoffapprovercanseetherequestsreceive'|
                                                        localize}}</span><br>
                                                    <span>
                                                        {{'Whenapproverclicksonanyrecord' | localize}}
                                                    </span><br>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Products & Services -->
                    <div id="productandservices" *ngIf="listArray[9].isShown">
                        <div class="row ml-5 ">
                            <div class="section_header col-md">
                                <h5>
                                    <img class="img-size"
                                        src="https://intimeprosstorage.blob.core.windows.net/intimepros-cdn/products_services.svg"
                                        alt="">
                                    <b class="ml-5">{{ 'ProductsAndServices' | localize}} </b>

                                </h5>
                            </div>
                            <div class="col-md-2 sortable">
                                <span class="text-right" (click)="homePage()">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="#0095DA"
                                        class="bi bi-house-door mr-2" viewBox="0 0 16 16">
                                        <path
                                            d="M8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4.5a.5.5 0 0 0 .5-.5v-4h2v4a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146zM2.5 14V7.707l5.5-5.5 5.5 5.5V14H10v-4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v4H2.5z" />
                                    </svg><span class="mt-1 text-primary"> {{'Home'| localize}} </span>
                                </span>
                            </div>

                        </div>
                        <hr>
                        <div class="mt-1">
                            <div class="container">
                                <div class="accordion" id="accordionExample">
                                    <div class="card">
                                        <div class="card-head mb-0" data-toggle="collapse" aria-controls="collapseOne"
                                            id="headingOne" (click)="accordianOpen(0)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{'WhatisProduct' | localize}}
                                                </li>
                                            </h2>
                                        </div>

                                        <div id="collapseOne" class="show" aria-labelledby="headingOne">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    {{'SubProductsareused' | localize}}
                                                </div>
                                                <div class="text-muted ml-5">
                                                    {{'Productsareused' | localize}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseTwo" id="headingTwo" (click)="accordianOpen(1)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{'HowtocreatenewProduct' |localize}}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo">
                                            <div class="card-body">
                                                <div class="text-font ml-5">
                                                    {{'TocreateanewProduct' | localize}}
                                                </div>
                                                <ul>
                                                    <li>{{'Clickonthegear' | localize}}</li>
                                                    <li>{{'ClickonProducts' | localize}}</li>
                                                    <li>{{'FromProductstab' | localize}}</li>
                                                    <li>{{'EnteraNameforyour' | localize}}</li>
                                                    <li>{{'AddDescriptionif' | localize}}</li>
                                                    <li>{{'AddPricinginformations' | localize}}</li>
                                                    <li>{{'FromSettings' | localize}}</li>
                                                    <li>{{'ClickontheSave' | localize}}</li>
                                                </ul>
                                                <div class="text-muted ml-8">
                                                    {{'Newlycreatedproducts' | localize}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="collapsed card-head mb-0" data-toggle="collapse"
                                            aria-controls="collapseThree" id="headingThree" (click)="accordianOpen(2)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{
                                                    'WhatareServices' |
                                                    localize
                                                    }}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseThree" class="collapse" aria-labelledby="headingThree">
                                            <div class="card-body">
                                                <div class="text-muted mt-1 ml-5">
                                                    {{'Servicesareusedundertheproject' | localize}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseFour" id="headingFour" (click)="accordianOpen(3)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{'HowtocreatenewService' | localize}}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseFour" class="collapse" aria-labelledby="headingFour">
                                            <div class="card-body">
                                                <div class="text-font mt-1 ml-5">
                                                    {{'TocreateanewService' | localize}}
                                                </div>
                                                <ul>
                                                    <li>{{'Clickonthegearicon' | localize}}</li>
                                                    <li>{{'ClickonProductsandServices' | localize}}</li>
                                                    <li>{{'FromServicestabclick' | localize}}</li>
                                                    <li>{{'AddDescriptio' | localize}}</li>
                                                    <li>{{'AddPricinginformation' | localize}}</li>
                                                    <li>{{'FromSetting' | localize}}</li>
                                                    <li>{{'Checkthebillablecheckbox' | localize}}</li>
                                                    <li>{{'CheckAutomatically' | localize}}</li>
                                                    <li>{{'ClickontheSavebutton' | localize}}</li>
                                                </ul>
                                                <div class="text-muted mb-2 ml-5">
                                                    {{'Newlycreatedproduct' | localize}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseFive" id="headingFive" (click)="accordianOpen(4)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{'WhatisArchivedDeletedProducts' | localize}}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseFive" class="collapse" aria-labelledby="headingFive">
                                            <div class="card-body">
                                                <span class="text-font ml-5 mt-2">
                                                    {{'ArchivedList' |localize}}
                                                </span>
                                                <ul>
                                                    <li>
                                                        {{'Thisisthelistofrecords' | localize}}
                                                    </li>
                                                    <li>
                                                        {{'Usercanrestorethearchived' |localize}}
                                                    </li>
                                                    <li>
                                                        {{'Usercandeleteanyrecord' | localize}}
                                                    </li>
                                                    <li>
                                                        {{'Usercannoteditarchived' | localize}}
                                                    </li>
                                                    <li>
                                                        {{'Bulkoptionispresent' |localize}}
                                                    </li>
                                                    <li>
                                                        {{'Exportoptionisusedtoexport' |localize}}
                                                    </li>
                                                </ul>

                                                <span class="text-font ml-5 mt-2">
                                                    {{ 'DeletedList' | localize}}
                                                </span>
                                                <ul>
                                                    <li> {{'Recordswhicharedeleted' | localize
                                                        }}</li>
                                                    <li> {{'Usercanrestoredeleted' | localize}}</li>

                                                    <li> {{'Usercannoteditdeleted' |localize}}</li>

                                                    <li> {{'Bulkoptionispresents' | localize}}</li>

                                                    <li> {{'Exportoptionisused' | localize}}</li>

                                                    <li> {{'Deleteoptionfromdeleted' | localize}}</li>

                                                </ul>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Projects -->
                    <div id="project" *ngIf="listArray[2].isShown">
                        <div class="row ml-5 ">
                            <div class="section_header col-md">
                                <h5>
                                    <img class="img-size"
                                        src="https://intimeprosstorage.blob.core.windows.net/intimepros-cdn/projects.svg"
                                        alt="">
                                    <b class="ml-5">{{ 'Project' | localize}} </b>

                                </h5>
                            </div>
                            <div class="col-md-2 sortable">
                                <span class="text-right" (click)="homePage()">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="#0095DA"
                                        class="bi bi-house-door mr-2" viewBox="0 0 16 16">
                                        <path
                                            d="M8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4.5a.5.5 0 0 0 .5-.5v-4h2v4a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146zM2.5 14V7.707l5.5-5.5 5.5 5.5V14H10v-4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v4H2.5z" />
                                    </svg><span class="mt-1 text-primary"> {{'Home'| localize}} </span>
                                </span>
                            </div>

                        </div>
                        <hr>
                        <div class="mt-1">
                            <div class="container">
                                <div class="accordion" id="accordionExample">
                                    <div class="card">
                                        <div class="card-head mb-0" data-toggle="collapse" aria-controls="collapseOne"
                                            id="headingOne" (click)="accordianOpen(0)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{
                                                    'WhatareProjects' |
                                                    localize
                                                    }}
                                                </li>
                                            </h2>
                                        </div>

                                        <div id="collapseOne" class="show" aria-labelledby="headingOne">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    <span>
                                                        {{
                                                        'Projectsarecreatedforclient' |
                                                        localize
                                                        }}
                                                    </span>
                                                </div>
                                                <div class="text-font ml-5">
                                                    {{
                                                    'ActiveProjectList' |
                                                    localize
                                                    }}
                                                </div>
                                                <ul>
                                                    <li>{{'Thisisthelistofallactive' | localize}}</li>
                                                    <li>{{'Sortinghasfouroption' | localize}}</li>

                                                    <ul>
                                                        <li>
                                                            {{
                                                            'Newestontoptodisplay' |
                                                            localize
                                                            }}
                                                        </li>
                                                        <li>
                                                            {{
                                                            'Oldestontoptodisplay' |
                                                            localize
                                                            }}
                                                        </li>
                                                        <li>
                                                            {{
                                                            'Ratelowtohighandhigh' |
                                                            localize
                                                            }}
                                                        </li>
                                                    </ul>
                                                </ul>
                                                <ul>
                                                    <li>{{'FilterbyProjectistofilters' | localize}}</li>
                                                    <li>{{'FilterbyMemberistofilters' | localize}}</li>
                                                    <li>
                                                        {{'Exportoptionusedtoexportthedata' | localize}}
                                                    </li>
                                                    <li>{{'ActionoptionhasEdit' | localize}}</li>
                                                    <li>
                                                        {{
                                                        'Usercanarchiveordeletemultipleproject' |
                                                        localize
                                                        }}
                                                    </li>
                                                    <li>{{'Archivedanddeletedprojects' | localize}}</li>
                                                    <li>
                                                        {{'Usercanviewprojectdatabyselect' | localize}}
                                                    </li>
                                                    <li>
                                                        {{
                                                        'AddProjectusedtocreatenewproject' |
                                                        localize
                                                        }}
                                                    </li>
                                                </ul>


                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseTwo" id="headingTwo" (click)="accordianOpen(1)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{
                                                    'HowtoAddProject' |
                                                    localize
                                                    }}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    <span>
                                                        {{
                                                        'Youcanaddnewprojectbyopting' |
                                                        localize
                                                        }}
                                                    </span>
                                                </div>
                                                <div class="ml-5">
                                                    <span>
                                                        {{
                                                        'startprojectandcharge' |
                                                        localize
                                                        }}
                                                    </span><br>
                                                    <span>
                                                        {{
                                                        'projectandchargehourly' |
                                                        localize
                                                        }}
                                                    </span>
                                                </div>

                                                <div class="text-font ml-5">
                                                    {{
                                                    'Addnewprojectscreen' |
                                                    localize
                                                    }}
                                                </div>
                                                <ul>
                                                    <li>
                                                        {{
                                                        'EnterProjectnamedesc' |
                                                        localize
                                                        }}
                                                    </li>
                                                    <li> {{'Selectclient' | localize}}</li>
                                                    <li>
                                                        {{
                                                        'Addprojectdurationflatrate' |
                                                        localize
                                                        }}
                                                    </li>
                                                    <li>
                                                        {{
                                                        'Assignteammemberswiththeirstartdate' |
                                                        localize
                                                        }}
                                                    </li>
                                                    <li>
                                                        {{
                                                        'Addprojectservice' |
                                                        localize
                                                        }}
                                                    </li>
                                                    <li>
                                                        {{
                                                        'Youcanchangeprojecttype' |
                                                        localize
                                                        }}
                                                    </li>
                                                    <li>
                                                        {{
                                                        'Selecttimeoffapproverwhocanapprove' |
                                                        localize
                                                        }}
                                                    </li>
                                                    <li>
                                                        {{
                                                        'Selecttimesheetsubmissionfrequency' |
                                                        localize
                                                        }}
                                                    </li>
                                                    <li>
                                                        {{
                                                        'Usercanaddthreeleveloftimesheet' |
                                                        localize
                                                        }}
                                                    </li>
                                                    <li>
                                                        {{
                                                        'Selectclientapprover' |
                                                        localize
                                                        }}
                                                    </li>
                                                    <li>
                                                        {{
                                                        'Approverwindowisthetimeprovide' |
                                                        localize
                                                        }}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseThree" id="headingThree" (click)="accordianOpen(2)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{
                                                    'ProjectDetail' |
                                                    localize
                                                    }}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseThree" class="collapse" aria-labelledby="headingThree">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    <span> {{'AnyProjectsdetails' | localize}}</span>
                                                </div>
                                                <div class="ml-5">
                                                    <span>
                                                        {{
                                                        'Headersectionshasproject' |
                                                        localize
                                                        }}
                                                    </span><br>
                                                    <span>
                                                        {{
                                                        'Usercanedittheprojectinformation' |
                                                        localize
                                                        }}
                                                    </span>
                                                </div>

                                                <div class="text-font ml-5">
                                                    {{'Therearesixtabspresent' | localize}}
                                                </div>
                                                <ul>
                                                    <li>{{'AllassignedProject' | localize}}</li>
                                                    <li>{{'Calendarviewtoseeteam' | localize}}</li>
                                                    <li>
                                                        {{
                                                        'listoftasksaddedunderthisproject' |
                                                        localize
                                                        }}
                                                    </li>
                                                    <li>{{'Realtimeactivitiesofteam' | localize}}</li>
                                                    <li>{{'Listoftimesheetssubmit' | localize}}</li>
                                                    <li>{{'Listofinvoice' | localize}}</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseFour" id="headingFour" (click)="accordianOpen(3)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{'WhatisArchivedDeletedproject' | localize}}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseFour" class="collapse" aria-labelledby="headingFour">
                                            <div class="card-body">
                                                <div class="text-font ml-5">
                                                    {{
                                                    'ArchiveProjectList' |
                                                    localize
                                                    }}
                                                </div>
                                                <ul>
                                                    <li>{{'Thisisthelistofproj' | localize}}</li>
                                                    <li>{{'Usercanrestorethearchive' | localize}}</li>
                                                    <li>
                                                        {{
                                                        'Usercandeleteanyprojectfromarchive' |
                                                        localize
                                                        }}
                                                    </li>
                                                    <li>{{'Usercannoteditarchive' | localize}}</li>
                                                    <li>
                                                        {{'Bulkoptionpresentortorestore' | localize}}
                                                    </li>
                                                    <li>{{'Exportoptionisuses' | localize}}</li>
                                                </ul>

                                                <div class="text-font ml-5">
                                                    {{
                                                    'DeleteProjectList' |
                                                    localize
                                                    }}
                                                </div>
                                                <ul>
                                                    <li>
                                                        {{
                                                        'ProjectwhicharedeletedfromActive' |
                                                        localize
                                                        }}
                                                    </li>
                                                    <li>
                                                        {{'Usercanrestoredeleteproject' | localize}}
                                                    </li>
                                                    <li>{{'Usercannoteditdeleteprojec' | localize}}</li>
                                                    <li>{{'Restoremultipleproject' | localize}}</li>
                                                    <li>{{'Exportoptionisusetoexport' | localize}}</li>
                                                    <li>{{'Deleteoptionfromdeletelist' | localize}}</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- App Productivity -->
                    <div id="appproductivity" *ngIf="listArray[11].isShown">
                        <div class="row ml-5 ">
                            <div class="section_header col-md">
                                <h5>
                                    <img class="img-size"
                                        src="https://intimeprosstorage.blob.core.windows.net/intimepros-cdn/app_productivity.svg"
                                        alt="">
                                    <b class="ml-5">{{ 'AppProductivit' | localize}} </b>

                                </h5>
                            </div>
                            <div class="col-md-2 sortable">
                                <span class="text-right" (click)="homePage()">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="#0095DA"
                                        class="bi bi-house-door mr-2" viewBox="0 0 16 16">
                                        <path
                                            d="M8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4.5a.5.5 0 0 0 .5-.5v-4h2v4a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146zM2.5 14V7.707l5.5-5.5 5.5 5.5V14H10v-4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v4H2.5z" />
                                    </svg><span class="mt-1 text-primary"> {{'Home'| localize}} </span>
                                </span>
                            </div>
                        </div>
                        <hr>
                        <div class="mt-1">
                            <div class="container">
                                <div class="accordion" id="accordionExample">
                                    <div class="card">
                                        <div class="card-head mb-0" data-toggle="collapse" aria-controls="collapseOne"
                                            id="headingOne" (click)="accordianOpen(0)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{
                                                    'WhatisAppProductivity' |
                                                    localize
                                                    }}
                                                </li>
                                            </h2>
                                        </div>

                                        <div id="collapseOne" class=" show" aria-labelledby="headingOne">
                                            <div class="card-body">
                                                <div class="text-muted mt-1 ml-5">
                                                    <span>
                                                        {{
                                                        'Appproductivityiswhereyoucancategories' |
                                                        localize
                                                        }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseTwo" id="headingTwo" (click)="accordianOpen(1)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{'Categories' | localize}}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    <span> {{'Therearesix' | localize}}</span>
                                                </div>
                                                <span class="text-font ml-5">
                                                    {{
                                                    'Defaultcategorie' |
                                                    localize
                                                    }}
                                                </span>
                                                <ul>
                                                    <li>{{'OfficeApp' | localize}}</li>
                                                    <li>{{'DevelopmentTool' | localize}}</li>
                                                    <li>{{'SocialMedia' | localize}}</li>
                                                    <li>{{'Internet' | localize}}</li>
                                                    <li>{{'Entertainment' | localize}}</li>
                                                    <li>{{'Other' | localize}}</li>
                                                </ul>
                                                <div class="text-muted mt-1 ml-5">
                                                    <span>
                                                        {{
                                                        'Youcanaddnewcategory' |
                                                        localize
                                                        }}
                                                    </span><br>
                                                    <span>
                                                        {{
                                                        'Newlyaddedcategorywilldisplay' |
                                                        localize
                                                        }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseThree" id="headingThree" (click)="accordianOpen(2)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{
                                                    'ProductivityDef' |
                                                    localize
                                                    }}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseThree" class="collapse" aria-labelledby="headingThree">
                                            <div class="card-body">
                                                <div class="text-muted mt-1 ml-5">
                                                    <span>
                                                        {{
                                                        'Thisiswhereyoucanseeused' |
                                                        localize
                                                        }}
                                                    </span><br>
                                                    <span>
                                                        {{
                                                        'Productivitydefinitionis' |
                                                        localize
                                                        }}
                                                    </span>
                                                </div>
                                                <span class="ml-5">
                                                    {{
                                                    'Howtodefinetheappl' |
                                                    localize
                                                    }}
                                                </span>
                                                <ul>
                                                    <li>{{'Fromneutraltab' | localize}}</li>
                                                    <li>{{'Onceyoumovetheappl' | localize}}</li>
                                                </ul>
                                                <div class="text-muted mt-1 ml-5">
                                                    <span> {{'Productivityofemp' | localize}}</span>
                                                </div>

                                                <div class="text-muted mt-1 ml-5">
                                                    <span> {{'Ifyouwanttomake' | localize}}</span><br>
                                                    <span>
                                                        {{
                                                        'Ifyouwanttomakeany' |
                                                        localize
                                                        }}
                                                    </span><br>
                                                    <span>
                                                        {{
                                                        'Ifyouwanttomakeanyappli' |
                                                        localize
                                                        }}
                                                    </span><br>
                                                    <span>
                                                        {{
                                                        'PleaseNoteProd' |
                                                        localize
                                                        }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseFour" id="headingFour" (click)="accordianOpen(3)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{
                                                    'ProductivityCal' |
                                                    localize
                                                    }}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseFour" class="collapse" aria-labelledby="headingFour">
                                            <div class="card-body">
                                                <div class="text-muted mt-1 ml-5">
                                                    <span>
                                                        {{
                                                        'Youcancreateacustom' |
                                                        localize
                                                        }}
                                                    </span><br>
                                                    <span> {{'youcanseetheprod' | localize}}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Time Tracking -->
                    <div id="timetracking" *ngIf="listArray[5].isShown">
                        <div class="row ml-5 ">
                            <div class="section_header col-md">
                                <h5>
                                    <img class="img-size"
                                        src="https://intimeprosstorage.blob.core.windows.net/intimepros-cdn/time_tracking.svg"
                                        alt="">
                                    <b class="ml-5">{{ 'TimeTrackings' | localize}} </b>

                                </h5>
                            </div>
                            <div class="col-md-2 sortable">
                                <span class="text-right" (click)="homePage()">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="#0095DA"
                                        class="bi bi-house-door mr-2" viewBox="0 0 16 16">
                                        <path
                                            d="M8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4.5a.5.5 0 0 0 .5-.5v-4h2v4a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146zM2.5 14V7.707l5.5-5.5 5.5 5.5V14H10v-4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v4H2.5z" />
                                    </svg><span class="mt-1 text-primary"> {{'Home'| localize}} </span>
                                </span>
                            </div>

                        </div>
                        <hr>
                        <div class="mt-1">
                            <div class="container">
                                <div class="accordion" id="accordionExample">
                                    <div class="card">
                                        <div class="card-head mb-0" data-toggle="collapse" aria-controls="collapseOne"
                                            id="headingOne" (click)="accordianOpen(0)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{
                                                    'WhatisTimeTracking' |
                                                    localize
                                                    }}
                                                </li>
                                            </h2>
                                        </div>

                                        <div id="collapseOne" class="show" aria-labelledby="headingOne">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    {{'Timetrackingfeatureboostsyourteam' | localize}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="card-head mb-0 collapsed" data-toggle="collapse"
                                            aria-controls="collapseTwo" id="headingTwo" (click)="accordianOpen(1)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{
                                                    'WhatareTeamTasks' |
                                                    localize
                                                    }}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    {{'Thisiswhereyoucanadds' | localize}}
                                                </div>
                                                <ul>
                                                    <li>{{'Selectstheproject' | localize}}</li>
                                                    <li>{{'AddTaskname' | localize}}</li>
                                                    <li>{{'Assignittothemember' | localize}}</li>
                                                    <li>{{'Addtaskdescription' | localize}}</li>
                                                    <li>{{'Systeminfooptional' | localize}}</li>
                                                    <li>{{'Selectpriority' | localize}}</li>
                                                    <li>{{'Selectactivityname' | localize}}</li>
                                                    <li>
                                                        {{'Addoriginalestimateofthetask' | localize}}
                                                    </li>
                                                    <li>{{'Selectbillabilitystatus' | localize}}</li>
                                                    <li>{{'Addattachmentoptional' | localize}}</li>
                                                    <li>{{'Clickonsaves' | localize}}</li>
                                                </ul>
                                                <div class="text-muted ml-5">
                                                    <span>
                                                        {{
                                                        'Newaddedtaskwilldisplayonteam' |
                                                        localize
                                                        }}
                                                    </span><br>
                                                    <span>
                                                        {{
                                                        'Teamtasksisthelistofalltask' |
                                                        localize
                                                        }}
                                                    </span><br>
                                                    <span>
                                                        {{
                                                        'Youcanfilterthetasksbyapplyingfilterbyproject'
                                                        | localize
                                                        }}
                                                    </span><br>
                                                    <span>
                                                        {{
                                                        'Youcandeleteanytaskfromactionoption' |
                                                        localize
                                                        }}
                                                    </span><br>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseThree" id="headingThree" (click)="accordianOpen(2)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{
                                                    'HowtoImportTasks' |
                                                    localize
                                                    }}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseThree" class="collapse" aria-labelledby="headingThree">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    {{'Ifyourelookingtosave' | localize}}
                                                </div>
                                                <div class="text-muted ml-5">
                                                    {{'Thisiswhereyoucanadds' | localize}}
                                                </div>
                                                <ul>
                                                    <li>{{'ClickonImporttasksoption' | localize}}</li>
                                                    <li>
                                                        {{
                                                        'Fromthepopupdownloadthesamplefile' |
                                                        localize
                                                        }}
                                                    </li>
                                                    <li>
                                                        {{'Enteryourtaskdataintotheexcel' | localize}}
                                                    </li>
                                                    <li>{{'GotoTimeTracking' | localize}}</li>
                                                    <li>{{'Choosetheexcelfile' | localize}}</li>
                                                    <li>
                                                        {{
                                                        'Checknotificationsforimportfilestatus' |
                                                        localize
                                                        }}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseFour" id="headingFour" (click)="accordianOpen(3)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{
                                                    'WhatareMyTasks' |
                                                    localize
                                                    }}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseFour" class="collapse" aria-labelledby="headingFour">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    {{
                                                    'Eachusercanseethetasksassignedtotheminmytask' |
                                                    localize
                                                    }}
                                                </div>
                                                <div class="text-font ml-5">
                                                    {{'Headersectionofmytaskshas' | localize}}
                                                </div>
                                                <ul>
                                                    <li>
                                                        {{
                                                        'Totalprojectsthisisthecountofproject' |
                                                        localize
                                                        }}
                                                    </li>
                                                    <li>{{'TotalTrackedtime' | localize}}</li>
                                                    <li>{{'Arrivedat' | localize}}</li>
                                                    <li>{{'Timeatwork' | localize}}</li>
                                                </ul>
                                                <div class="text-muted ml-5">
                                                    {{
                                                    'Ontopofmytaskspagetasktimerispresent' |
                                                    localize
                                                    }}
                                                </div>
                                                <ul>
                                                    <li>{{'Busy' | localize}}</li>
                                                    <li>{{'Idle' | localize}}</li>
                                                    <li>{{'Onlines' | localize}}</li>
                                                    <li>{{'Offlines' | localize}}</li>
                                                    <li>{{'PrivateTime' | localize}}</li>
                                                </ul>
                                                <div>
                                                    <ul>
                                                        <li>{{'NewUser' | localize}}</li>
                                                        <li>{{'InProgress' | localize}}</li>
                                                        <li>{{'Overdues' | localize}}</li>
                                                        <li>{{'CompletedText' | localize}}</li>
                                                    </ul>
                                                  
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseFive" id="headingFive" (click)="accordianOpen(4)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{
                                                    'WhatisMyCalendar' |
                                                    localize
                                                    }}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseFive" class="collapse" aria-labelledby="headingFive">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    {{
                                                    'Mycalendariswherethetaskisrepresent' |
                                                    localize
                                                    }}<br>
                                                    {{'Usercanintegratetheirgoogle' | localize}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Timesheets   -->
                    <div id="timesheet" *ngIf="listArray[6].isShown">
                        <div class="row ml-5 ">
                            <div class="section_header col-md">
                                <h5>
                                    <img class="img-size"
                                        src="https://intimeprosstorage.blob.core.windows.net/intimepros-cdn/timesheet.svg"
                                        alt="">
                                    <b class="ml-5">{{ 'Timesheet' | localize}} </b>

                                </h5>
                            </div>
                            <div class="col-md-2 sortable">
                                <span class="text-right" (click)="homePage()">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="#0095DA"
                                        class="bi bi-house-door mr-2" viewBox="0 0 16 16">
                                        <path
                                            d="M8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4.5a.5.5 0 0 0 .5-.5v-4h2v4a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146zM2.5 14V7.707l5.5-5.5 5.5 5.5V14H10v-4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v4H2.5z" />
                                    </svg><span class="mt-1 text-primary"> {{'Home'| localize}} </span>
                                </span>
                            </div>

                        </div>
                        <hr>
                        <div class="mt-1">
                            <div class="container">
                                <div class="accordion" id="accordionExample">
                                    <div class="card">
                                        <div class="card-head mb-0" data-toggle="collapse" aria-controls="collapseOne"
                                            id="headingOne" (click)="accordianOpen(0)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{
                                                    'WhatareTimesheets' |
                                                    localize
                                                    }}
                                                </li>
                                            </h2>
                                        </div>

                                        <div id="collapseOne" class="show" aria-labelledby="headingOne">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    {{'Timesheetisasimple' | localize}}<br>
                                                    {{'Youcanrecordyourdaily' | localize}}<br>
                                                    {{'ThenormalworkflowbehindTimesheet' | localize}}
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseTwo" id="headingTwo" (click)="accordianOpen(1)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{
                                                    'Whatareprojects' |
                                                    localize
                                                    }}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    {{
                                                    'Atimesheetisacollectionofmorethanonetime' |
                                                    localize
                                                    }}<br>
                                                    {{'Youcanusefilterbyprojectoption' | localize}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseThree" id="headingThree" (click)="accordianOpen(2)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{
                                                    'Howtosubmittimesheet' |
                                                    localize
                                                    }}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseThree" class="collapse" aria-labelledby="headingThree">
                                            <div class="card-body">
                                                <div class="text-font ml-5">
                                                    {{'Followbelowstepstosubmittimesheet' | localize}}
                                                </div>
                                                <ul>
                                                    <li>{{'Gotoprojecttab' | localize}}</li>
                                                    <li>
                                                        {{'Youwillseetaskslistforwhichtime' | localize}}
                                                    </li>
                                                    <li>
                                                        {{
                                                        'Selectthedateforwhichyouwanttosubmit' |
                                                        localize
                                                        }}
                                                    </li>
                                                    <li>{{'Keepshowintimesheet' | localize}}</li>
                                                    <li>
                                                        {{'Youcanaddcommentforeachtask' | localize}}
                                                    </li>
                                                    <li>{{'Youcanseetrackhistory' | localize}}</li>
                                                    <li>{{'Ifyouwanttoaddanytask' | localize}}</li>
                                                    <ul>
                                                        <li>
                                                            {{
                                                            'Fromrightsidepanelyouneedtoaddtask' |
                                                            localize
                                                            }}
                                                        </li>
                                                        <li>
                                                            {{'Selectstartdateandenddate' | localize}}
                                                        </li>
                                                        <li>
                                                            {{
                                                            'Selectbillabilitystatusofthetask' |
                                                            localize
                                                            }}
                                                        </li>
                                                        <li>{{'Clickonsavebutton' | localize}}</li>
                                                    </ul>
                                                    <li>{{'Clickonsubmitbutton' | localize}}</li>
                                                    <li>{{'Ifapprovalsareconfigured' | localize}}</li>
                                                    <li>
                                                        {{'Ifapprovalsarenotconfigured' | localize}}
                                                    </li>
                                                </ul>
                                                <div class="text-muted ml-5">
                                                    {{
                                                    'Youcanfiltertaskbybillabilitystatus' |
                                                    localize
                                                    }}<br>
                                                    {{
                                                    'Ifyouwanttoseeyourprevioustimesheet' |
                                                    localize
                                                    }}<br>
                                                    {{'Headerhas' | localize}}
                                                </div>
                                                <ul>
                                                    <li>{{'EstimatedBillablehour' | localize}}</li>
                                                    <li>{{'LoggedBillablehour' | localize}}</li>
                                                    <li>{{'Remaininghour' | localize}}</li>
                                                    <li>{{'TimesheetFrequency' | localize}}</li>
                                                </ul>
                                                <div class="text-muted ml-5">
                                                    {{'Autosavefunctionality' | localize}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseFour" id="headingFour" (click)="accordianOpen(3)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{
                                                    'Whataremytimesheets' |
                                                    localize
                                                    }}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseFour" class="collapse" aria-labelledby="headingFour">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    {{'Youcanseeyoursubmittedtimesheet' | localize}}<br>
                                                    {{'Youcanfilteryourtimesheet' | localize}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseFive" id="headingFive" (click)="accordianOpen(4)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{
                                                    'Whataretimesheetapprovals'
                                                    | localize
                                                    }}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseFive" class="collapse" aria-labelledby="headingFive">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    {{'Ifyouarepartofleveloftimesheet' | localize}}<br>
                                                    {{'Youcanaddcommentsontasklevel' | localize}}
                                                </div>
                                                <div class="ml-5">
                                                    {{
                                                    'Intimeproprovidesoption' |
                                                    localize
                                                    }}
                                                </div>
                                                <ul>
                                                    <li>
                                                        {{
                                                        'Youcanselectthedaterangefromthetop' |
                                                        localize
                                                        }}
                                                    </li>
                                                    <li>
                                                        {{
                                                        'Headersectiondisplaystotalmembercount' |
                                                        localize
                                                        }}
                                                    </li>
                                                    <li>
                                                        {{'Totalleavesarethecountofleaves' | localize}}
                                                    </li>
                                                    <li>
                                                        {{
                                                        'Totalloggedhoursarethehourslogged' |
                                                        localize
                                                        }}
                                                    </li>
                                                    <li>
                                                        {{
                                                        'Totalbilledhoursarehoursapproved' |
                                                        localize
                                                        }}
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseSix" id="headingSix" (click)="accordianOpen(5)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{
                                                    'Whatissummary' |
                                                    localize
                                                    }}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseSix" class="collapse" aria-labelledby="headingSix">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    {{'Thisisthesummaryviewoftimesheet' | localize}}<br>
                                                    {{'Thisisthelistviewtimesheets' | localize}}<br>
                                                    {{
                                                    'Onclickofapprovedandsubmittedoption' |
                                                    localize
                                                    }}<br>
                                                    {{'Youcansendremindertoteammember' | localize}}<br>
                                                    {{'Summarytabhasoptiontofilter' | localize}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Manage User -->
                    <div id="manageuser" *ngIf="listArray[10].isShown">
                        <div class="row ml-5 ">
                            <div class="section_header col-md">
                                <h5>
                                    <img class="img-size"
                                        src="https://intimeprosstorage.blob.core.windows.net/intimepros-cdn/manage_users.svg"
                                        alt="">
                                    <b class="ml-5">{{ 'ManageUsers' | localize}} </b>

                                </h5>
                            </div>
                            <div class="col-md-2 sortable">
                                <span class="text-right" (click)="homePage()">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="#0095DA"
                                        class="bi bi-house-door mr-2" viewBox="0 0 16 16">
                                        <path
                                            d="M8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4.5a.5.5 0 0 0 .5-.5v-4h2v4a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146zM2.5 14V7.707l5.5-5.5 5.5 5.5V14H10v-4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v4H2.5z" />
                                    </svg><span class="mt-1 text-primary"> {{'Home'| localize}} </span>
                                </span>
                            </div>

                        </div>
                        <hr>
                        <div class="mt-1">
                            <div class="container">
                                <div class="accordion" id="accordionExample">
                                    <div class="card">
                                        <div class="card-head mb-0" data-toggle="collapse" aria-controls="collapseOne"
                                            id="headingOne" (click)="accordianOpen(0)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{
                                                    'WhatisManageUsers' |
                                                    localize
                                                    }}
                                                </li>
                                            </h2>
                                        </div>

                                        <div id="collapseOne" class="show" aria-labelledby="headingOne">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    {{'SubThisiswhereyouinvitee' | localize}}
                                                </div>
                                                <div class="text-muted ml-5">
                                                    {{'Thisiswhereyouinvite' | localize}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseTwo" id="headingTwo" (click)="accordianOpen(1)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{
                                                    'HowdoIinviteaTeamMember' |
                                                    localize
                                                    }}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    {{'AsanOwnerworking' | localize}}
                                                </div>
                                                <span class="text-font ml-5">
                                                    {{
                                                    'SendanInvite' |
                                                    localize
                                                    }}
                                                </span>
                                                <ul>
                                                    <li>{{'ClickonSettings' | localize}}</li>
                                                    <li>{{'ClickontheInviteUser' | localize}}</li>
                                                    <li>{{'Selecttheroleyouwant' | localize}}</li>
                                                    <li>{{'Enteruserdetails' | localize}}</li>
                                                    <li>{{'Selectthereporting' | localize}}</li>
                                                    <li>{{'Addpaidleaves' | localize}}</li>
                                                    <li>{{'ThenclickonSave' | localize}}</li>
                                                    <li>{{'Yourteammember' | localize}}</li>
                                                </ul>

                                                <span class="text-font ml-5">
                                                    {{
                                                    'LoginAccessprovided' |
                                                    localize
                                                    }}
                                                </span>
                                                <ul>
                                                    <li>{{'LoginwithMicrosoft' | localize}}</li>
                                                    <li>{{'LoginwithGoogle' | localize}}</li>
                                                    <li>{{'Loginwithintimepro' | localize}}</li>
                                                </ul>
                                                <div class="text-muted ml-5">
                                                    {{'Usingthisrandompassword' | localize}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseThree" id="headingThree" (click)="accordianOpen(2)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{
                                                    'HowtoImportusers' |
                                                    localize
                                                    }}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseThree" class="collapse" aria-labelledby="headingThree">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    {{'Ifyourelooking' | localize}}
                                                </div>
                                                <span class="text-font ml-5">
                                                    {{
                                                    'Usercanimportteam' |
                                                    localize
                                                    }}
                                                </span>
                                                <ul>
                                                    <li>{{'ClickonImportUser' | localize}}</li>
                                                    <li>{{'Fromthepopupdownload' | localize}}</li>
                                                    <li>{{'Enteryourusers' | localize}}</li>
                                                    <li>{{'Gotointimepro' | localize}}</li>
                                                    <li>{{'Checknotifications' | localize}}</li>
                                                    <li>{{'Choosetheexcelfileofusers' | localize}}</li>
                                                </ul>

                                                <div class="ml-5">
                                                    {{
                                                    'Onceyoudonewithadding' |
                                                    localize
                                                    }}
                                                </div>
                                                <ul>
                                                    <li>{{'EmailSent' | localize}}</li>
                                                    <li>{{'Joinedon' | localize}}</li>
                                                </ul>
                                                <div class="text-muted ml-5">
                                                    {{'Activeuserlist' | localize}}<br>
                                                    {{'Exportoptionispresent' | localize}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseFour" id="headingFour" (click)="accordianOpen(3)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{
                                                    'Howtoedituserdetails' |
                                                    localize
                                                    }}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseFour" class="collapse" aria-labelledby="headingFour">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    {{'Youcaneditthedata' | localize}}
                                                </div>
                                                <span class="text-font ml-5">
                                                    {{
                                                    'Editpagehasmore' |
                                                    localize
                                                    }}
                                                </span>
                                                <ul>
                                                    <li>{{'PersonalInfo' | localize}}</li>
                                                    <li>{{'AccountInformations' | localize}}</li>
                                                    <li>{{'ChangePasswords' | localize}}</li>
                                                    <li>{{'Leave' | localize}}</li>
                                                    <li>{{'AppAndProductivitys' | localize}}</li>
                                                    <li>{{'SettingsCapture' | localize}}</li>
                                                </ul>


                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseFive" id="headingFive" (click)="accordianOpen(4)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{'WhatisArchivedDeletedmanageuser' | localize}}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseFive" class="collapse" aria-labelledby="headingFive">
                                            <div class="card-body">
                                                <span class="text-font ml-5">
                                                    {{
                                                    'ArchivedUserList' |
                                                    localize
                                                    }}
                                                </span>
                                                <ul>
                                                    <li>{{'Thisisthelistoftheuser' | localize}}</li>
                                                    <li>{{'Admincanrestorethearchived' | localize}}</li>
                                                    <li>{{'Admincan' | localize}}</li>
                                                    <li>{{'Admincannot' | localize}}</li>
                                                    <li>{{'Bulkoptionis' | localize}}</li>
                                                    <li>{{'Exportoptionis' | localize}}</li>
                                                </ul>

                                                <span class="text-font ml-5">
                                                    {{
                                                    'DeletedUserList' |
                                                    localize
                                                    }}
                                                </span>
                                                <ul>
                                                    <li>{{'Userswhohavedeleted' | localize}}</li>
                                                    <li>{{'Admincanrestore' | localize}}</li>
                                                    <li>{{'Admincannotedit' | localize}}</li>
                                                    <li>{{'Bulkoptionispresentto' | localize}}</li>
                                                    <li>{{'Exportoptionisuseds' | localize}}</li>
                                                    <li>{{'Deleteoptionfromdelete' | localize}}</li>
                                                </ul>
                                                <span class="ml-5">
                                                    {{
                                                    'NoteArchivedandDeleted' |
                                                    localize
                                                    }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Clients -->
                    <div id="client" *ngIf="listArray[1].isShown">
                        <div class="row ml-5 ">
                            <div class="section_header col-md">
                                <h5>
                                    <img class="img-size"
                                        src="https://intimeprosstorage.blob.core.windows.net/intimepros-cdn/clients.svg"
                                        alt="">
                                    <b class="ml-5">{{ 'Clients' | localize}} </b>

                                </h5>
                            </div>
                            <div class="col-md-2 sortable">
                                <span class="text-right" (click)="homePage()">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="#0095DA"
                                        class="bi bi-house-door mr-2" viewBox="0 0 16 16">
                                        <path
                                            d="M8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4.5a.5.5 0 0 0 .5-.5v-4h2v4a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146zM2.5 14V7.707l5.5-5.5 5.5 5.5V14H10v-4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v4H2.5z" />
                                    </svg><span class="mt-1 text-primary"> {{'Home'| localize}} </span>
                                </span>
                            </div>
                        </div>
                        <hr>
                        <div class="mt-1">
                            <div class="container">
                                <div class="accordion" id="accordionExample">
                                    <div class="card">
                                        <div class="card-head mb-0" data-toggle="collapse" aria-controls="collapseOne"
                                            id="headingOne" (click)="accordianOpen(0)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{
                                                    'WhoareClients' |
                                                    localize
                                                    }}
                                                </li>
                                            </h2>
                                        </div>

                                        <div id="collapseOne" class="show" aria-labelledby="headingOne">
                                            <div class="card-body">
                                              
                                                <div class="text-muted ml-5">
                                                    {{'Clientsarethepeople' | localize}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseTwo" id="headingTwo" (click)="accordianOpen(1)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{
                                                    'ClientDashboard' |
                                                    localize
                                                    }}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    {{'ItdisplaystheOverdue' | localize}}
                                                </div>
                                                <span class="text-font ml-5">
                                                    {{
                                                    'ActiveClientLists' |
                                                    localize
                                                    }}
                                                </span>
                                                <ul>
                                                    <li>{{'Thisisthelistview' | localize}}</li>
                                                    <li>{{'UsercanEdit' | localize}}</li>
                                                    <li>{{'Usercanuseexportoption' | localize}}</li>
                                                    <li>{{'Usercanusesearch' | localize}}</li>
                                                    <li>{{'AddClientisused' | localize}}</li>
                                                </ul>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseThree" id="headingThree" (click)="accordianOpen(2)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{
                                                    'Howtocreatenewclients' |
                                                    localize
                                                    }}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseThree" class="collapse" aria-labelledby="headingThree">
                                            <div class="card-body">
                                                <span class="text-muted ml-5">
                                                    {{
                                                    'AddClientbuttonused' |
                                                    localize
                                                    }}
                                                </span>
                                                <ul>
                                                    <li>
                                                        {{'EnterCompanyNameAddressline' | localize}}
                                                    </li>
                                                    <li>{{'Uploadphotooption' | localize}}</li>
                                                    <li>{{'Usercanaddmultiplecontacts' | localize}}</li>
                                                    <ul>
                                                        <li>
                                                            {{
                                                            'Usercanaddcontact' |
                                                            localize
                                                            }}
                                                        </li>
                                                    </ul>
                                                </ul>
                                                <div class="text-font ml-5">
                                                    {{'Therearetwotypes' | localize}}<br>
                                                </div>
                                                <ul>
                                                    <li>{{'TechnicalContacts' | localize}}</li>
                                                    <li>{{'BillingContacts' | localize}}</li>
                                                </ul>
                                                <span class="ml-9">
                                                    {{
                                                    'Usercanmakeanycontactasprimary'
                                                    | localize
                                                    }}
                                                </span><br>
                                                <span class="ml-9">
                                                    {{
                                                    'Usercaneditthecontact' |
                                                    localize
                                                    }}
                                                </span><br>

                                                <span class="text-font ml-5">
                                                    {{
                                                    'Settingsinvoice' |
                                                    localize
                                                    }}
                                                </span><br>
                                                <ul>
                                                    <li>
                                                        {{
                                                        'SendPaymentReminder' |
                                                        localize
                                                        }}
                                                    </li>
                                                    <li> {{'Usercanadd' | localize}}</li>
                                                    <li>
                                                        {{
                                                        'Usercandeleteany' |
                                                        localize
                                                        }}
                                                    </li>
                                                </ul>
                                                <span class="text-font ml-5">
                                                    {{
                                                    'ChargeLateFee' |
                                                    localize
                                                    }}
                                                </span><br>
                                                <span class="ml-5">
                                                    {{
                                                    'YoucanChargeLateFee' |
                                                    localize
                                                    }}
                                                </span>
                                                <ul>
                                                    <li>{{'PercentageTochargelatefees' | localize}}</li>
                                                    <li>{{'Ifthetotalbill' | localize}}</li>
                                                    <li>{{'enteranyflatamount' | localize}}</li>
                                                    <li>{{'Ifthetotalbillvalue' | localize}}</li>
                                                </ul>

                                                <ul>
                                                    <span class="">
                                                        {{
                                                        'Youcanaddup' |
                                                        localize
                                                        }}
                                                    </span>
                                                    <br>
                                                    <li>{{'Toaddtaxs' | localize}}</li>
                                                    <li>{{'Todeletetax' | localize}}</li>
                                                </ul>
                                                <span class="ml-5">{{'CurrencyLang' | localize}}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseFour" id="headingFour" (click)="accordianOpen(3)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{'ClientDetail' | localize}}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseFour" class="collapse" aria-labelledby="headingFour">
                                            <div class="card-body">
                                                <span class="text-muted ml-5">
                                                    {{'Detailsoftheclientlikeorg' | localize}}
                                                </span>
                                                <ul>
                                                    <li>
                                                        {{'InDraftamountisthetotalamount' | localize}}
                                                    </li>
                                                    <li>{{'Unbilledtimeisthetotal' | localize}}</li>
                                                    <li>
                                                        {{'Usercanedittheclientdetails' | localize}}
                                                    </li>
                                                    <li>{{'GenerateStatement' | localize}}</li>
                                                </ul>
                                                <span class="ml-5">
                                                    {{
                                                    'Therearetwotabspresent' |
                                                    localize
                                                    }}
                                                </span>
                                                <ul>
                                                    <li>{{'InvoiceAlltheinvoices' | localize}}</li>
                                                    <li>{{'ProjectsAlltheprojects' | localize}}</li>
                                                </ul>

                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseFive" id="headingFive" (click)="accordianOpen(4)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{'WhatisArchivedDeletedClient' | localize}}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseFive" class="collapse" aria-labelledby="headingFive">
                                            <div class="card-body">
                                                <span class="text-font ml-5">
                                                    {{
                                                    'ArchivedClientLists' |
                                                    localize
                                                    }}
                                                </span>
                                                <ul>
                                                    <li>{{'Thisisthelis' | localize}}</li>
                                                    <li>{{'Usercanrestor' | localize}}</li>
                                                    <li>{{'Usercandeletean' | localize}}</li>
                                                    <li>{{'Usercannotedi' | localize}}</li>
                                                    <li>{{'Bulkoptionispresen' | localize}}</li>
                                                    <li>{{'Exportoptionisusedto' | localize}}</li>
                                                </ul>

                                                <span class="text-font ml-5">
                                                    {{
                                                    'DeletedClientLists' |
                                                    localize
                                                    }}
                                                </span>
                                                <ul>
                                                    <li>{{'Clientswhohasdelete' | localize}}</li>
                                                    <li>{{'Usercanrestoredelete' | localize}}</li>
                                                    <li>{{'Usercannoteditdelete' | localize}}</li>
                                                    <li>{{'Bulkoptionispre' | localize}}</li>
                                                    <li>{{'Exportoptionisuse' | localize}}</li>
                                                    <li>{{'Bulkoptionispres' | localize}}</li>
                                                    <li>{{'Deleteoptionfromdelet' | localize}}</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Activities -->
                    <div id="activities" *ngIf="listArray[4].isShown">
                        <div class="row ml-5 ">
                            <div class="section_header col-md">
                                <h5>
                                    <img class="img-size"
                                        src="https://intimeprosstorage.blob.core.windows.net/intimepros-cdn/activities.svg"
                                        alt="">
                                    <b class="ml-5">{{ 'Activities' | localize}} </b>

                                </h5>
                            </div>
                            <div class="col-md-2 sortable">
                                <span class="text-right" (click)="homePage()">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" fill="#0095DA"
                                        class="bi bi-house-door mr-2" viewBox="0 0 16 16">
                                        <path
                                            d="M8.354 1.146a.5.5 0 0 0-.708 0l-6 6A.5.5 0 0 0 1.5 7.5v7a.5.5 0 0 0 .5.5h4.5a.5.5 0 0 0 .5-.5v-4h2v4a.5.5 0 0 0 .5.5H14a.5.5 0 0 0 .5-.5v-7a.5.5 0 0 0-.146-.354L13 5.793V2.5a.5.5 0 0 0-.5-.5h-1a.5.5 0 0 0-.5.5v1.293L8.354 1.146zM2.5 14V7.707l5.5-5.5 5.5 5.5V14H10v-4a.5.5 0 0 0-.5-.5h-3a.5.5 0 0 0-.5.5v4H2.5z" />
                                    </svg><span class="mt-1 text-primary"> {{'Home'| localize}} </span>
                                </span>
                            </div>

                        </div>
                        <hr>
                        <div class="mt-1">
                            <div class="container">
                                <div class="accordion" id="accordionExample">
                                    <div class="card">
                                        <div class="card-head mb-0" data-toggle="collapse" aria-controls="collapseOne"
                                            id="headingOne" (click)="accordianOpen(0)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{
                                                    'WhatareActivities' |
                                                    localize
                                                    }}
                                                </li>
                                            </h2>
                                        </div>

                                        <div id="collapseOne" class="show" aria-labelledby="headingOne">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    {{'Activitiesfeaturesmakeiteasy' | localize}}<br>
                                                    {{'letsyouknowabouttheactivities' | localize}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseTwo" id="headingTwo" (click)="accordianOpen(1)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{
                                                    'HowRealTimeTrackingworks'
                                                    | localize
                                                    }}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseTwo" class="collapse" aria-labelledby="headingTwo">
                                            <div class="card-body">
                                                <div class="text-font ml-5 ">
                                                    {{
                                                    'TeamTracking' |
                                                    localize
                                                    }}
                                                </div>
                                                <div class="text-muted ml-5">
                                                    {{'Trackrealtimeactivities' | localize}}<br>
                                                    {{'Headerpartdisplaystrackeddata' | localize}}
                                                </div>
                                                <ul>
                                                    <li>{{'Totalnumberofemployee' | localize}}</li>
                                                    <li>
                                                        {{
                                                        'Currentlyworkingaretheemployees' |
                                                        localize
                                                        }}
                                                    </li>
                                                    <li>
                                                        {{
                                                        'CurrentlySlackingaretheemployees' |
                                                        localize
                                                        }}
                                                    </li>
                                                    <li>
                                                        {{
                                                        'Currentlyofflinearetheemployees' |
                                                        localize
                                                        }}
                                                    </li>
                                                    <li>
                                                        {{'Productivityofactiveemployees' | localize}}
                                                    </li>

                                                    <li>{{'organizationisused' | localize}}</li>
                                                    <li>{{'projectisused' | localize}}</li>
                                                    <li>{{'memberisused' | localize}}</li>
                                                    <li>
                                                        {{
                                                        'SortingNewestontopandOldestontop' |
                                                        localize
                                                        }}
                                                    </li>
                                                    <li>{{'Teamtrackinglistdisplay' | localize}}</li>

                                                    <li>{{'Youcantakelivescreenshot' | localize}}</li>
                                                    <li>
                                                        {{'Youcanclickonanymembersrecord' | localize}}
                                                    </li>
                                                    <!-- <li>{{'Membernameprofileimg' | localize}}</li> -->
                                                </ul>

                                                <div class="text-font ml-5 ">
                                                    {{
                                                    'ProductivityTab' |
                                                    localize
                                                    }}
                                                </div>
                                                <ul>
                                                    <li> {{'Productivitydetail' | localize}}</li>
                                                    <li> {{'Productivitybar' | localize}}</li>
                                                    <li> {{'Applicationusagebase' | localize}}</li>
                                                    <li> {{'Capturedscreenshot' | localize}}</li>
                                                </ul>
                                                <div class="text-font ml-5 ">
                                                    {{'PendingTab' | localize}}
                                                </div>
                                                <ul>
                                                    <li>
                                                        {{'Teammembersubmitstheiroffline' | localize}}
                                                    </li>
                                                    <li>
                                                        {{'Pendinglistiswhereyoucansee' | localize}}
                                                    </li>
                                                    <li> {{'exportthelisttopdf' | localize}}</li>
                                                    <li>
                                                        {{'totaltimeofofflinetimeentries' | localize}}
                                                    </li>
                                                    <li>
                                                        {{
                                                        'productivetimesubmittedbymembers' |
                                                        localize
                                                        }}
                                                    </li>
                                                    <li>
                                                        {{
                                                        'unproductivetimesubmittedbymember' |
                                                        localize
                                                        }}
                                                    </li>
                                                    <li>
                                                        {{
                                                        'totalneutraltimesubmittedbymembers' |
                                                        localize
                                                        }}
                                                    </li>
                                                </ul>

                                                <div class="text-font ml-5 ">
                                                    {{
                                                    'ApprovedTabs' |
                                                    localize
                                                    }}
                                                </div>
                                                <ul>
                                                    <li>{{'Onceofflinetimeofteam' | localize}}</li>
                                                    <li>
                                                        {{
                                                        'Totalofflinetimeisthetotaltime' |
                                                        localize
                                                        }}
                                                    </li>
                                                    <li>{{'Productiveistotal' | localize}}</li>
                                                    <li>
                                                        {{
                                                        'Unproductiveistotalunproductive' |
                                                        localize
                                                        }}
                                                    </li>
                                                    <li>{{'Neutralistotalneutral' | localize}}</li>
                                                </ul>

                                                <div class="text-font ml-5 ">
                                                    {{
                                                    'DeclinedTabs' |
                                                    localize
                                                    }}
                                                </div>
                                                <ul>
                                                    <li>
                                                        {{'Onceofflinetimeofteammember' | localize}}
                                                    </li>
                                                    <li>
                                                        {{
                                                        'Exportoptionisusedtoexportthelistinpdf' |
                                                        localize
                                                        }}
                                                    </li>
                                                    <li>
                                                        {{'Totalofflinetimeisthetotal' | localize}}
                                                    </li>
                                                    <li>
                                                        {{'Productiveistotalproductive' | localize}}
                                                    </li>
                                                    <li> {{'Unproductiveistotal' | localize}}</li>
                                                    <li> {{'Neutralistotalneutraltime' | localize}}</li>
                                                </ul>

                                                <div class="text-font ml-5 ">
                                                    {{
                                                    'LocationTrackings' |
                                                    localize
                                                    }}
                                                </div>
                                                <div class="ml-5">
                                                    {{'Locationtrackingallow' | localize}}<br>
                                                    {{'Locationtrackingtrack' | localize}}<br>
                                                    {{'Youcanclickonanyuser' | localize}}<br>

                                                </div>
                                                <ul>
                                                    <li> {{'Usernameprofilepictures' | localize}}</li>
                                                    <li> {{'IPaddofuser' | localize}}</li>
                                                    <li> {{'Lastworktime' | localize}}</li>
                                                    <li> {{'Locatio' | localize}}</li>
                                                    <li> {{'Workstatuss' | localize}}</li>
                                                    <li> {{'Youcanclickonviewdetails' | localize}}</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseThree" id="headingThree" (click)="accordianOpen(2)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{
                                                    'WhatisTimeandAttendance' |
                                                    localize
                                                    }}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseThree" class="collapse" aria-labelledby="headingThree">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    {{
                                                    'Youcanseeyourtrackedactivitiesintime' |
                                                    localize
                                                    }}
                                                </div>
                                                <span class="ml-5">
                                                    {{
                                                    'Yournameprofileimagerole' |
                                                    localize
                                                    }}
                                                </span>
                                                <div class="ml-5 ">
                                                    {{
                                                    'ProductivityTabCal' |
                                                    localize
                                                    }}
                                                </div>
                                                <div class="ml-5">
                                                    {{
                                                    'ProductivitydetailsArrivalTime'
                                                    | localize
                                                    }}<br>
                                                    <li>
                                                        {{
                                                        'DisplaysproductiveProductivitybar' |
                                                        localize
                                                        }}
                                                    </li>
                                                    <li>
                                                        {{'Applicationusagebasedonapp' | localize}}
                                                    </li>
                                                    <li>
                                                        {{
                                                        'Capturedscreenshotsofyourmachine' |
                                                        localize
                                                        }}
                                                    </li>
                                                </div>
                                                <div class="text-muted ml-5">
                                                    {{'Youcanaddyourofflinetime' | localize}}<br>
                                                    {{'Youcanselectprivatetimemode' | localize}}<br>
                                                    {{
                                                    'Piechartviewofapplicationtrackingshow' |
                                                    localize
                                                    }}<br>
                                                    {{
                                                    'Screenshotsatthebottomarethecaptured' |
                                                    localize
                                                    }}<br>
                                                    {{'Ifyouwanttoseeyourtrackedactivities' | localize}}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseFour" id="headingFour" (click)="accordianOpen(3)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{
                                                    'Whatarescreenshots' |
                                                    localize
                                                    }}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseFour" class="collapse" aria-labelledby="headingFour">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    {{
                                                    'Youcansetmultiplescreencapturingrequests' |
                                                    localize
                                                    }}<br>
                                                    {{
                                                    'Allactivitiesincludinghourlyscreenshots' |
                                                    localize
                                                    }}<br>
                                                    {{
                                                    'Toseescreenshotsofanyuseryoucanfilter' |
                                                    localize
                                                    }}<br>
                                                    {{'Sortingwillsortthescreenshots' | localize}}<br>
                                                    {{
                                                    'Screenshotcapturingisdividedintoslots' |
                                                    localize
                                                    }}<br>
                                                    {{
                                                    'Additionallyagentappdeterminesifemployees' |
                                                    localize
                                                    }}<br>
                                                    {{
                                                    'Ifyouwanttoseethescreenshotsofanyprevious' |
                                                    localize
                                                    }}<br>

                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="card">
                                        <div class="collapsed card-head mb-0 " data-toggle="collapse"
                                            aria-controls="collapseFive" id="headingFive" (click)="accordianOpen(4)">
                                            <h2>
                                                <li class="text-font mt-2">
                                                    {{'Whatareappsandwebsites' |localize}}
                                                </li>
                                            </h2>
                                        </div>
                                        <div id="collapseFive" class="collapse" aria-labelledby="headingFive">
                                            <div class="card-body">
                                                <div class="text-muted ml-5">
                                                    {{'Thisisanintelligentwork' | localize}}<br>
                                                    {{'Youcancheckbothindividualusageandteam' |localize}}

                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                </div>
                <div class="col-md-3 ">
                    <div class="card w-13 h-70 border mt-12 ml-2 pl-5 bg-light position-fixed">
                        <div class="mt-4 ml-5 category"><b>{{ 'allcategories' | localize }} </b></div>
                        <hr>
                        <div class="mr-5 mt-2">
                            <ul class="sortable">
                                <ng-container *ngFor="let item of listArray; index as i">
                                    <div class="py-2 d-flex">
                                        <div class="rounded mt-2 mr-2" [ngClass]="bgColorList" [id]="item.label"
                                            style="height: 5px; width:5px;"></div>
                                        <a (click)="toggleBtn(item.label)">{{item.label | localize}}</a>
                                    </div>
                                </ng-container>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>


        </div>
